export default "__VITE_ASSET__BoCYDocR__"